/**
 * Намерение, с которым человек ПРИШЁЛ на страницу чата участника с лендинга
 * приглашения (WEB-19 §4.1/§4.3, реестр Д-2):
 *  - `resumed` — сервер не завёл нового участника, а продолжил прежнего с этого
 *    устройства; `typedName` — имя, набранное в форме и НЕ применённое
 *    (человек получит его применить явно, кнопкой);
 *  - `rename` — человек пришёл менять подпись: форма открывается сама.
 *
 * Почему модуль в памяти, а не state роутера. Страница участника живёт без
 * `useLocation` (её тесты и вкладка-невидимка монтируют её без Router), а
 * переход с лендинга — SPA-навигация в том же JS-контексте (урок WEB-19a: полная
 * перезагрузка убивала и сессию в памяти). Намерение читается ОДИН раз — после
 * перезагрузки его нет, и это правильно: оно относится к приходу, а не к
 * странице.
 *
 * 🔴 Читать в инициализаторе `useState` можно ТОЛЬКО без React.StrictMode: там
 * инициализатор зовётся дважды, и второй вызов получил бы null (намерение
 * съедено первым). Приложение StrictMode не включает (`src/index.js`) — как и
 * остальной код (aside, PlanEditor); включая его, перевести чтение на ref.
 */
let pending = null;

/** @param {{resumed?: boolean, typedName?: string|null, rename?: boolean}|null} intent */
export function setArrivalIntent(intent) {
  pending = intent ? { ...intent } : null;
}

/** Забрать намерение и стереть: второй вызов вернёт null. */
export function takeArrivalIntent() {
  const out = pending;
  pending = null;
  return out;
}
